
/**
 * Parse availability window from different sources (host settings, weekly availability, defaults)
 */
export function parseAvailabilityWindow(window: { startTime: string; endTime: string }) {
  try {
    // Handle time formats like "09:00:00" or "09:00"
    const parseTime = (timeStr: string) => {
      const parts = timeStr.split(':');
      const hour = parseInt(parts[0], 10);
      const minute = parts.length > 1 ? parseInt(parts[1], 10) : 0;
      return { hour, minute };
    };

    const start = parseTime(window.startTime);
    const end = parseTime(window.endTime);

    return {
      startHour: start.hour,
      startMinute: start.minute,
      endHour: end.hour,
      endMinute: end.minute
    };
  } catch (error) {
    console.error('[parseAvailabilityWindow] Error parsing times:', error);
    // Fallback to 9 AM - 5 PM
    return {
      startHour: 9,
      startMinute: 0,
      endHour: 17,
      endMinute: 0
    };
  }
}
